// =============================================
// COMPONENTE: InternalAPINode - Nó de API Interna
// =============================================
// Arquivo: InternalAPINode.tsx
// Descrição: Nó para chamadas diretas às rotas internas do backend
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Server, Database, ArrowRight } from 'lucide-react';
import ActionsBadge from './ActionsBadge';
import '../NodeStyles.css';

const InternalAPINode: React.FC<NodeProps> = ({ data, selected }) => {
  const {
    label,
    endpoint,
    method = 'GET',
    entity,
    operation,
    description,
    actions
  } = data;

  const getOperationIcon = (operation: string) => {
    switch (operation) {
      case 'create': return '➕';
      case 'read': return '📖';
      case 'update': return '✏️';
      case 'delete': return '🗑️';
      case 'list': return '📋';
      default: return '⚡';
    }
  };

  return (
    <div className={`flow-node internal-api-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        className="flow-handle"
      />

      <div className="node-header internal-api-header">
        <Server className="node-icon" size={18} />
        <span className="node-title">{label || 'Internal API'}</span>
      </div>

      <div className="node-body">
        {entity && (
          <div className="node-detail">
            <Database size={14} />
            <span className="node-detail-text">
              {getOperationIcon(operation)} {entity}
            </span>
          </div>
        )}
        {endpoint && (
          <div className="node-detail">
            <ArrowRight size={14} />
            <span className="node-detail-text">
              <strong>{method}</strong> {endpoint}
            </span>
          </div>
        )}
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="flow-handle"
      />
    </div>
  );
};

export default InternalAPINode;
